<template>
  <div class="analitycs-block">
    <div class="change-status-payments-block">
      <button
        :class="[
          `status-button ${activeAnalyticType === 'expense' && 'active'}`,
        ]"
        @click="setChangeType('expense')"
      >
        {{ $t("analytics.costTiitle") }}
      </button>
      <button
        :class="[
          `status-button ${activeAnalyticType === 'income' && 'active'}`,
        ]"
        @click="setChangeType('income')"
      >
        {{ $t("analytics.incomeTitle") }}
      </button>
      <!-- <button :class="[`status-button ${usedStatusButton === 3 && 'active'}`]"
        @click="setChangeType(3)">{{
        $t('analytics.transferTitle') }}</button> -->
    </div>
    <date-fIlter-list
      :value="currentAnalyticDate"
      :analyticsFilter="true"
      @open-filter="openFilter"
    />
    <analitycs-chart
      v-if="mainAnalytics.length"
      :series="series"
      :options="options"
      :allSpent="setCountTotalSum(mainAnalytics)"
    />
    <p v-if="mainAnalytics.length" class="info-chart-list-title">
      {{ $t("analytics.tapOnTransaction") }}
    </p>
    <p v-else class="info-chart-list-title is-null-analytics-list">
      {{ $t("analytics.nullAnalytics") }}
    </p>
    <ul class="payments-list">
      <!-- <vue-perfect-scrollbar class="main-scroll-area">
         <transition-group name="fade" mode="out-in"> -->
      <li
        v-for="recent of mainAnalytics"
        :key="recent.category.id"
        class="payments-element"
        @click="setIsOpenAnalitycsInfo(recent)"
      >
        <div v-if="recent.category.img" class="payments-element-image-block">
          <img
            :src="recent.category.img"
            alt=""
            class="payments-element-image-icon"
          />
        </div>
        <div v-else class="payments-element-image-block">
          <user-icon class="payments-element-image-icon" />
        </div>
        <div class="payments-element-name-block">
          <p class="payments-element-name">{{ recent.category.title }}</p>
          <!-- <p class="payments-element-date">{{ recent.category.title }}</p> -->
        </div>
        <div class="payments-element-price-block">
          <p class="payment-percentage">
            {{ calculatePercentage(recent.sum) }}%
          </p>
          <p :class="[`payments-element-price ${currentTypeColor}`]">
            {{
              `${
                currentTypeColor === "expense" ? "-" : ""
              }${returnCurrencySymbol(getMainCurrency)} ${recent.sum}`
            }}
          </p>
          <!-- <p class="payments-element-price-origin">{{ recent.type.title }}</p> -->
        </div>
      </li>
      <!-- </transition-group>
             </vue-perfect-scrollbar> -->
    </ul>
  </div>
</template>

<script>
// import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DateFIlterList from "../../../components/DateFIlterList.vue";
import { UserIcon } from "vue-feather-icons";
import AnalitycsChart from "../../../components/charts/AnalitycsChart.vue";
import { mapMutations } from "vuex";
import { onVibrate } from "../../../helpers/utils";

export default {
  name: "Analitycs-page",
  components: {
    DateFIlterList,
    // VuePerfectScrollbar,
    AnalitycsChart,
    UserIcon,
  },
  props: {
    currentAnalyticDate: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      isOpenAnalitycsInfo: false,
      options: {
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true,
          custom: ({ seriesIndex, w }) => {
            const label = w.config.labels[seriesIndex];
            const value = w.globals.series[seriesIndex];
            const currency = this.returnCurrencySymbol(this.getMainCurrency);
            return `
              <div style="padding: 10px; background-color: #fff; color: #000; border-radius: 5px; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);">
                <strong>${label}</strong>: ${value} ${currency}
              </div>
            `;
          },
        },
        chart: {
          type: "donut",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const { seriesIndex } = config;

              if (typeof seriesIndex !== "undefined") {
                const label = config.w.config.labels[seriesIndex];
                const value = config.w.globals.series[seriesIndex];
                alert(
                  `${label}: ${value} ${this.returnCurrencySymbol(
                    this.getMainCurrency
                  )}`
                );
              }
            },
          },
        },
        labels: [],
        dataLabels: {
          enabled: false,
        },
      },
      currencySymbol: {
        1: "₴",
        2: "$",
        4: "€",
        6: "zł",
        7: "₴",
      },
      series: [10, 10, 10],
      totalSum: 0,
      usedStatusButton: 1,
      currentTypeColor: "cost",
    };
  },
  async mounted() {
    this.series = this.mainAnalytics.map((el) => el.sum);
  },

  methods: {
    ...mapMutations([
      "setIsOpenGlobalAnalitycsBlock",
      "setSaveOpenedOperation",
      "setChangeActiveAnalyticType",
    ]),
    setIsOpenAnalitycsInfo(value) {
      onVibrate("click");
      let type = this.typeOperations.find(
        (el) => el.slug === this.activeAnalyticType
      );
      let data = {
        account_id: this.currentCustomer.id,
        platform_id: this.currentCustomer.platform_id,
        type_id: type.id,
        from: this.getMonthFirstAndLastDay(this.currentAnalyticDate.date)
          .firstDay,
        to: this.getMonthFirstAndLastDay(this.currentAnalyticDate.date).lastDay,
        category_id: value.category.id,
      };
      this.$store.dispatch("getAnalyticsOperations", data).then(() => {
        this.setSaveOpenedOperation(value);
        this.setIsOpenGlobalAnalitycsBlock(true);
      });
    },
    returnCurrencySymbol(currency) {
      if (this.currencySymbol[currency.id]) {
        return this.currencySymbol[currency.id];
      } else {
        return currency.code_alfa;
      }
    },
    calculatePercentage(targetNumber) {
      if (this.mainAnalytics.length === 0) {
        return 0;
      }
      let totalSum = 0;
      for (const number of this.mainAnalytics) {
        totalSum += number.sum;
      }
      const percentage = (targetNumber / totalSum) * 100;
      const roundedPercentage = percentage.toFixed(1);
      return roundedPercentage;
    },
    setChangeType(val) {
      onVibrate("click");
      let type = this.typeOperations.find((el) => el.slug === val);
      this.setChangeActiveAnalyticType(val);
      this.$emit(
        "let-filter-analytics",
        this.currentAnalyticDate.date,
        type.id
      );
    },
    openFilter() {
      this.$emit("on-open-filter-fixed-block");
    },
    getMonthFirstAndLastDay(customMounth) {
      const now = new Date();
      const year = now.getFullYear();
      let month;
      if (customMounth) {
        month = customMounth;
      } else {
        month = now.getMonth();
      }

      let firstDayOfMonth;
      let lastDayOfMonth;

      if (customMounth) {
        firstDayOfMonth = new Date(year, month - 1, 1);
        lastDayOfMonth = new Date(year, month, 0);
      } else {
        firstDayOfMonth = new Date(year, month, 1);
        lastDayOfMonth = new Date(year, month + 1, 0);
      }

      const firstDay = this.formatDate(firstDayOfMonth);
      const lastDay = this.formatDate(lastDayOfMonth);

      return { firstDay, lastDay };
    },
    setCountTotalSum(value) {
      let total = 0;

      for (const obj of value) {
        total += obj.sum;
      }
      return Number(total.toFixed(2));
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
  },
  beforeDestroy() {
    this.setChangeActiveAnalyticType("expense");
  },
  computed: {
    mainAnalytics() {
      return this.$store.getters.mainAnalytics;
    },
    currentCustomer() {
      return this.$store.getters.currentCustomer;
    },
    getMainCurrency() {
      return this.$store.getters.getMainCurrency;
    },
    activeAnalyticType() {
      return this.$store.getters.activeAnalyticType;
    },
    typeOperations() {
      return this.$store.getters.typeOperations;
    },
  },
  watch: {
    mainAnalytics(newVal, oldVal) {
      this.series = newVal.map((el) => el.sum);
      let data = {
        ...this.options,
        labels: newVal.map((el) => el.category.title),
      };
      this.options = data;
      let val = oldVal;
      val;
      this.currentTypeColor = this.activeAnalyticType;
    },
  },
};
</script>

<style scoped>
.analitycs-block {
  overflow: hidden;
  border-radius: 22px;
  margin: 0px 15px 30px 15px;
  border: none;
  box-shadow: 10px 10px 10px #d1d9e6, -10px -10px 10px #f9f9f9;
  background: #fff;
}

.main-chart-block {
  position: relative;
}

.total-summ-chart-block {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.total-summ-chart-title {
  font-size: 25px;
  line-height: 30px;
  font-weight: 700;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
  letter-spacing: -0.6px;
  text-align: center;
}

.total-summ-chart-info {
  font-size: 12px;
  opacity: 0.5;
  font-weight: 400;
  text-align: center;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
  letter-spacing: -0.6px;
}

.info-chart-list-title {
  opacity: 0.3;
  text-align: center;
  padding-bottom: 16px;
  font-size: 11px;
  line-height: 20px;
  font-weight: 700;
  letter-spacing: 0px;
  color: #1b1b1b;
  font-family: "Source Sans Pro", sans-serif;
}

.is-null-analytics-list {
  margin-top: 70px;
  margin-bottom: 50px;
}

.payments-list {
  list-style: none;
  padding: 10px 15px;
}

.payments-element {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  text-decoration: none;
  cursor: pointer;
}

.payments-element:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.payments-element-image-block {
  width: 45px;
  height: 45px;
  border-radius: 15px;
  background-image: var(--main-bg-color);
  display: flex;
  margin-right: 10px;
}

.payments-element-image-icon {
  color: #fff;
  margin: auto;
  width: 25px;
}

.payments-element-name {
  font-family: "Source Sans 3", sans-serif;
  color: #1b1b1b;
  font-size: 16px;
  line-height: 39px;
  font-weight: 700;
  margin-bottom: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}

.payments-element-date {
  color: #747474;
  margin-bottom: 30px;
  letter-spacing: -0.2px;
  font-size: 11px;
  opacity: 0.7;
  margin-bottom: 0px;
  line-height: 12px;
}
.payments-element-name-block {
  padding-top: 4px;
}

.payment-percentage {
  margin-bottom: 0px;
  color: #4a89dc;
  font-size: 18px;
  line-height: 39px;
  font-weight: 700;
  font-family: "Source Sans 3", sans-serif;
  letter-spacing: -0.6px;
  text-align: end;
  margin-right: 10px;
}

.payments-element-price-block {
  margin-left: auto;
  padding-top: 4px;
  display: flex;
}

.payments-element-price {
  margin-bottom: 0px;
  color: #8cc152;
  font-size: 18px;
  line-height: 39px;
  font-weight: 700;
  font-family: "Source Sans 3", sans-serif;
  letter-spacing: -0.6px;
  text-align: end;
}

.payments-element-price.income {
  color: #8cc152;
}

.payments-element-price.expense {
  color: #d84558;
}

.payments-element-price.transfer {
  color: #4a89dc;
}

.payments-element-price-origin {
  margin-bottom: 0px;
  font-size: 11px;
  color: #747474;
  padding-bottom: 0px;
  letter-spacing: -0.2px;
  text-align: right;
  line-height: 12px;
}

.change-status-payments-block {
  background-color: rgba(0, 0, 0, 0.07);
  overflow: hidden;
  display: flex;
  padding: 5px;
  border-radius: 20px;
  margin: 10px;
}

.status-button {
  transition: all 200ms ease;
  text-align: center;
  width: 100%;
  margin: auto;
  color: #000;
  line-height: 35px;
  font-size: 13px;
  background-size: cover;
  position: relative;
  z-index: 10;
  overflow: visible;
  background-color: transparent;
  transition: all 0.5s ease;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
}

.status-button.active {
  background-image: var(--main-bg-color);
  color: #fff !important;
}

.main-scroll-area {
  width: 100%;
  max-height: 45vh;
  min-height: 20vh;
  padding: 10px 15px 10px 15px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
